import React, { useState, useEffect, useRef } from "react";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTable from "../useTable";
import { Dimmer } from "../spinner";
import { Mensaje, MensajeSiNo } from "../mensajes";
import axios from "axios";
import { Toasts } from "../toasts";
import { ActualizarRentasInmobiliarias } from "./modalActualizarRentas";
import moment from "moment";
import { EstadodeCuenta } from "./modalEstadodeCuenta";
import { formatMoneda } from "../../util/varios";

const TablaRentasInmobiliarias = (props) => {
  var op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));
  const accrentasinm = JSON.parse(localStorage.getItem("accrentasinm"));
  let municipios = [];

  const fechaSistema = JSON.parse(localStorage.getItem("fechasistema"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CÓDIGO",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "INMUEBLE",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DIRECCIÓN",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "ARRENDATARIO",
      textAlign: "center",
    },
    {
      id: "opciones",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: " OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [agentes, setAgentes] = useState([]);
  const [idciu, setIdciu] = useState();
  const [operacion, setOperacion] = useState(0);
  const [valormoneda, setValormoneda] = useState(0);
  const [rentas, setRentas] = useState();
  const [persona, setPersona] = useState();
  const [agente, setAgente] = useState();
  const [inmueble, setInmueble] = useState();
  const [estado, setEstado] = useState();
  const [municipio, setMunicipio] = useState();
  const [deuda, setDeuda] = useState();
  const [historico, setHistorico] = useState();
  const [verificacion, setVerificacion] = useState();
  const [facturasC, setFacturasC] = useState();
  const [totDeuda, setTotDeuda] = useState(0);
  const [ciudad, setCiudad] = useState();
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const accoprentas = JSON.parse(localStorage.getItem("accoprentas"));
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  let el;
  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idrentas.includes(target.value) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.nombre.toLowerCase().includes(target.value.toLowerCase()) ||
              x.direccion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };

  const SeleccionarRentaEstadoCuenta = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/rentas/consultaestadosdecuenta?id=${id}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idrentas !== "") {
            setAgentes(response.data);
            SelectVerificacion(response.data);
          } else {
            setAgentes();
            SelectVerificacion(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SelectVerificacion = (data) => {
    let tipo = "17";

    let endpoint = `${
      op.conexion
    }/api/comun/consultaverificaciones?idcontribuyente=${parseInt(
      data.idagente
    )}&idtipoingreso=${tipo}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setVerificacion(response.data);
            seleccionarFacturasContribuyente(data);
          } else {
            setVerificacion([]);
            seleccionarFacturasContribuyente(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarFacturasContribuyente = (data) => {
    let tabla = "renta";
    let endpoint = `${op.conexion}/api/comun/facturasxcontribuyente?id=${data.idagente}&nomtab=${tabla}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            SelectDeudaAgenRentas(data);
            setFacturasC(response.data);
          } else {
            SelectDeudaAgenRentas(data);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const SelectDeudaAgenRentas = (data) => {
    let endpoint = `${op.conexion}/api/minas/deudas?idagente=${
      data.idagente
    }&fecha=${fechaSistema}&tabconf=${"configrentas"}&condic=${"tipodeuda=17"}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var deu = [];
          var his = [];
          var totdeu = parseFloat(0.0);
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].fechapago === null) {
              totdeu =
                totdeu +
                parseFloat(response.data[i].mondeu) +
                parseFloat(response.data[i].intmoradeu) +
                parseFloat(response.data[i].recargodeu) +
                parseFloat(response.data[i].multa);
              deu.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                retenciones: response.data[i].retencion,
                credito: response.data[i].acreditacion,
                totalperi: response.data[i].subtotal,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                nummes: response.data[i].nmes,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            } else {
              his.push({
                anio: response.data[i].anio,
                mes: response.data[i].mes.replace("'", "").replace("'", ""),
                monto: response.data[i].mondeu,
                intereses: response.data[i].intmoradeu,
                recargo: response.data[i].recargodeu,
                multa: response.data[i].multa,
                descuento: response.data[i].mondescue,
                recibo: response.data[i].numreci,
                fechapago: response.data[i].fechapago,
                status: response.data[i].estatus,
                idfac: response.data[i].idfact,
                estatusfac: response.data[i].estatusfac,
                tipotransaccion: response.data[i].tipotransaccion,
              });
            }
          }
          setDeuda(deu);
          setHistorico(his);
        }
        setMostrar3(true);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRegistros = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/rentas/consultarentas`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
          txtBuscador.current.focus();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const SeleccionarRenta = (id) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "rentas";
    let nomid = "idrentas";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idrentas > 0) {
            setRentas(response.data);
            SeleccionarInmueble(response.data);
          } else {
            setRentas();
            SeleccionarInmueble(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarInmueble = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "inmuebles";
    let nomid = "idinmuebles";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idinmuebles}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idinmuebles > 0) {
            setInmueble(response.data);
            seleccionarEstado(response.data);
            SeleccionarAgente(data);
          } else {
            setInmueble();
            SeleccionarAgente(data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarAgente = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "agente";
    let nomid = "idagente";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.idagente}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idagente > 0) {
            setAgente(response.data);
            setIdciu(response.data.ciudad);
            SeleccionarPersona(response.data);
          } else {
            setAgente();
            SeleccionarPersona(response.data);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const SeleccionarPersona = (data) => {
    setActivate(true);

    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.reprelegal}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.cedula > 0) {
            setPersona(response.data);
            setMostrar2(true);
          } else {
            setPersona();
            setMostrar2(true);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarEstado = (data) => {
    setActivate(true);

    let campos = "idestado, trim(nombre)  AS nombre";
    let nomtab = "estado";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.estado}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idestado > 0) {
            setEstado(response.data);
            seleccionarMunicipio(data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMunicipio = (data) => {
    let campos = "idmunicipio, trim(nombre)  AS nombre";
    let nomtab = "municipio";
    let nomid = "idmunicipio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.municipio}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idmunicipio > 0) {
            seleccionarCiudad(data);
            setMunicipio(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudad = (data) => {
    let campos = "idciudad, trim(nombre)  AS nombre";
    let nomtab = "ciudad";
    let nomid = "idciudad";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data.ciudad}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idciudad > 0) {
            setCiudad(response.data);
            setActivate(false);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarTipoMoneda = () => {
    setActivate(true);

    let tabla = "valordolarbcv";
    let anio = fechaSistema.substring(0, 4);
    let fecha = moment(fechaSistema).format("YYYY-MM-DD");

    let endpoint = `${op.conexion}/api/rentas/consultatipomoneda?tabla=${tabla}&anio=${anio}&fecha=${fecha}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setValormoneda(response.data[0].valor);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarActuProgramatica = (op, data) => (e) => {
    if (op === 4) {
      if (accoprentas.substring(0, 1) !== "0") {
        setOperacion(4);
        SeleccionarRenta(data.idrentas, op);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 1) {
      if (accoprentas.substring(1, 2) !== "0") {
        setOperacion(op);
        setMostrar2(true);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 2) {
      if (accoprentas.substring(2, 3) !== "0") {
        setOperacion(op);
        SeleccionarRenta(data.idrentas, op);
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 3) {
      if (accoprentas.substring(3, 4) !== "0") {
        if (data.valido > 0) {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto:
              "No puede Eliminar este Contribuyente ya que Posee una Deuda!",
            icono: "error",
          });
        } else {
          setOperacion(op);
          SeleccionarRenta(data.idrentas, op);
        }
      } else {
        setToast({
          ...toast,
          mostrar: true,
          titulo: "Notificación",
          mensaje: "No Posee los Permisos para Realizar esta Acción",
        });
      }
    } else if (op === 5) {
      setOperacion(op);
      SeleccionarRentaEstadoCuenta(data.idrentas, op);
    }
  };

  const cerrarToast = () => {
    setToast({
      mostrar: false,
    });
  };

  useEffect(() => {
    SeleccionarRegistros();
    seleccionarTipoMoneda();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  const handleCancela2 = () => {
    setMostrar3(false);
  };

  return (
    <div className="p-0 m-0" style={{ height: "100%", width: "100%" }}>
      <div className="row col-md-12" style={{ margin: 0 }}>
        <div className="row col-md-12 py-3" style={{ margin: 0 }}>
          <div className="col-md-10 py-3 mx-auto mt-5">
            <div className="col-12 p-2">
              <div className="row col-12 d-flex justify-content-between">
                <input
                  type="text"
                  className=" col-2 form-control form-control-sm rounded-pill"
                  ref={txtBuscador}
                  onChange={handleSearch}
                  placeholder="Buscar"
                />

                <div className="col-3 d-flex justify-content-end">
                  <button
                    onClick={gestionarActuProgramatica(1, "", "")}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Incluir"
                    style={{ marginBottom: "5px" }}
                    className={
                      accoprentas.substring(1, 2) === "0"
                        ? "btn btn-sm btn-secondary rounded-circle"
                        : "btn btn-sm btn-primary rounded-circle"
                    }
                  >
                    <i className="fas fa-plus"></i>{" "}
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-12 m-0">
              <TblContainer>
                <TblHead />
                <TableBody>
                  {records &&
                    recordsAfterPagingAndSorting().map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "40px",
                          }}
                        >
                          {item.idrentas}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "left",
                            alignItems: "center",
                            width: "150px",
                          }}
                        >
                          {item.descripcion}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "left",
                            alignItems: "center",
                            width: "200px",
                          }}
                        >
                          {item.direccion}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "left",
                            alignItems: "center",
                            width: "100px",
                          }}
                        >
                          {item.nombre}
                        </TableCell>
                        <TableCell
                          className="align-baseline"
                          style={{
                            textAlign: "center",
                            alignItems: "center",
                            width: "80px",
                          }}
                        >
                          {item.valido > 0 ? (
                            <button
                              onClick={gestionarActuProgramatica(5, item)}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Posee Deuda el Contribuyente"
                              className={
                                accrentasinm.substring(2, 3) === "0"
                                  ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                  : "btn btn-sm mx-1 btn-success rounded-circle"
                              }
                            >
                              <i className="fas fa-hand-holding"></i>{" "}
                            </button>
                          ) : (
                            ""
                          )}
                          <button
                            onClick={gestionarActuProgramatica(4, item)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Consultar"
                            className={
                              accoprentas.substring(0, 1) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-info rounded-circle"
                            }
                          >
                            <i className="fas fa-eye"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarActuProgramatica(2, item)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Editar"
                            className={
                              accoprentas.substring(2, 3) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-warning rounded-circle"
                            }
                          >
                            <i className="fa fa-edit"></i>{" "}
                          </button>
                          <button
                            onClick={gestionarActuProgramatica(3, item)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Eliminar"
                            className={
                              accoprentas.substring(3, 4) === "0"
                                ? "btn btn-sm mx-1 btn-secondary rounded-circle"
                                : "btn btn-sm mx-1 btn-danger rounded-circle"
                            }
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
              <TblPagination />
            </div>
          </div>
        </div>
      </div>
      <ActualizarRentasInmobiliarias
        show={mostrar2}
        operacion={operacion}
        rentas={rentas}
        persona={persona}
        inmueble={inmueble}
        estado={estado}
        municipio={municipio}
        ciudad={ciudad}
        valmoneda={valormoneda}
        agente={agente}
        idciu={idciu}
        onHideCancelar={handleCancelar}
        onHideRenderizar={SeleccionarRegistros}
      />

      <EstadodeCuenta
        show={mostrar3}
        operacion={operacion}
        agente={agentes}
        tabdeuda={deuda}
        verific={verificacion}
        factura={facturasC}
        tabpago={historico}
        onHideCancela={handleCancela2}
      />

      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
    </div>
  );
};
export default TablaRentasInmobiliarias;



// WEBPACK FOOTER //
// ./src/components/rentas/tablaRentas.js